import { Skeleton } from '@/components/ui/skeleton'
import WrapperCard from '@/components/fragments/wrapper-card'
import { CreditCardIcon, PercentIcon } from '@/assets/svg'

const FinancialSettingsSkeleton = () => {
  return (
    <div className='space-y-6 mt-4'>
      <div className='grid grid-cols-1 lg:grid-cols-2 gap-6'>
        {/* Commission & Service Fees Card */}
        <WrapperCard
          title='Commission & Service Fees'
          icon={PercentIcon}
          wrapperClassName='h-fit'
          headerClassName='flex flex-row-reverse justify-end items-center gap-2'
        >
          <div className='space-y-6 mt-4'>
            {/* Service Charge Percentage */}
            <div className='bg-[#FAFAFA] rounded-[1.15rem] p-4'>
              <Skeleton className='h-4 w-40 mb-2' />
              <Skeleton className='h-10 w-full rounded-[8px] mb-1' />
              <Skeleton className='h-3 w-32' />
            </div>

            {/* Delivery Charge Percentage */}
            <div className='bg-[#FAFAFA] rounded-[1.15rem] p-4'>
              <Skeleton className='h-4 w-44 mb-2' />
              <Skeleton className='h-10 w-full rounded-[8px] mb-1' />
              <Skeleton className='h-3 w-40' />
            </div>

            {/* Vendor Commission */}
            <div className='bg-[#FAFAFA] rounded-[1.15rem] p-4'>
              <Skeleton className='h-4 w-32 mb-2' />
              <Skeleton className='h-10 w-full rounded-[8px] mb-1' />
              <Skeleton className='h-3 w-36' />
            </div>

            {/* Platform Commission */}
            <div className='bg-[#FAFAFA] rounded-[1.15rem] p-4'>
              <Skeleton className='h-4 w-48 mb-2' />
              <Skeleton className='h-10 w-full rounded-[8px] mb-1' />
              <Skeleton className='h-3 w-40' />
            </div>
          </div>
        </WrapperCard>

        {/* Payment Processing Card */}
        <WrapperCard
          title='Payment Processing'
          icon={CreditCardIcon}
          wrapperClassName='h-fit'
          headerClassName='flex flex-row-reverse justify-end items-center gap-2'
        >
          <div className='space-y-6 mt-4'>
            {/* Stripe Fee */}
            <div className='bg-[#FAFAFA] rounded-[1.15rem] p-4'>
              <Skeleton className='h-4 w-20 mb-2' />
              <Skeleton className='h-10 w-full rounded-[8px] mb-1' />
              <Skeleton className='h-3 w-36' />
            </div>

            {/* Tax Rate */}
            <div className='bg-[#FAFAFA] rounded-[1.15rem] p-4'>
              <Skeleton className='h-4 w-16 mb-2' />
              <Skeleton className='h-10 w-full rounded-[8px] mb-1' />
              <Skeleton className='h-3 w-40' />
            </div>

            {/* Minimum Withdrawal */}
            <div className='bg-[#FAFAFA] rounded-[1.15rem] p-4'>
              <Skeleton className='h-4 w-32 mb-2' />
              <Skeleton className='h-10 w-full rounded-[8px] mb-1' />
              <Skeleton className='h-3 w-48' />
            </div>

            {/* Maximum Withdrawal */}
            <div className='bg-[#FAFAFA] rounded-[1.15rem] p-4'>
              <Skeleton className='h-4 w-32 mb-2' />
              <Skeleton className='h-10 w-full rounded-[8px] mb-1' />
              <Skeleton className='h-3 w-48' />
            </div>
          </div>
        </WrapperCard>
      </div>

      {/* Revenue Breakdown Preview Skeleton */}
      <div className='bg-white rounded-[1.15rem] p-6'>
        <div className='flex justify-between items-center mb-6'>
          <Skeleton className='h-6 w-48' />
          <div className='flex gap-3'>
            <Skeleton className='h-10 w-20' />
            <Skeleton className='h-10 w-20' />
          </div>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4'>
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className='bg-[#FAFAFA] rounded-[1.15rem] p-4'>
              <Skeleton className='h-4 w-24 mb-2' />
              <Skeleton className='h-8 w-16 mb-1' />
              <Skeleton className='h-3 w-20' />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default FinancialSettingsSkeleton
